export type Variant = 'filled' | 'outlined' | 'soft-outlined';
export type Color = 'default' | 'primary' | 'error';

export type Palette = {
  color: string;
  bgColor: string;
  border: string;
  hover: {
    color: string;
    bgColor: string;
    border: string;
  };
};

export const defaultPalette: Palette = {
  color: 'var(--primary-600)',
  bgColor: 'var(--primary-contrast)',
  border: 'var(--primary-600)',
  hover: {
    color: 'var(--primary-700)',
    bgColor: 'var(--primary-50)',
    border: 'var(--primary-700)',
  },
};

const getPalette: (variant?: Variant, color?: Color) => Palette = (
  variant = 'filled',
  color = 'default',
) => {
  let colors = {
    main: '',
    mainDarkened: '',
    contrast: '',
    contrastDarkened: '',
    light: '',
    lightDarkened: '',
    lighter: '',
    lighterDarkened: '',
  };

  switch (color) {
    case 'primary':
      colors = {
        main: 'var(--primary-600)',
        mainDarkened: 'var(--primary-700)',
        contrast: 'var(--primary-contrast)',
        contrastDarkened: 'var(--primary-50)',
        light: 'var(--primary-600)',
        lightDarkened: 'var(--primary-700)',
        lighter: 'var(--primary-50)',
        lighterDarkened: 'var(--primary-100)',
      };
      break;

    case 'error':
      colors = {
        main: 'var(--error-600)',
        mainDarkened: 'var(--error-700)',
        contrast: 'var(--error-contrast)',
        contrastDarkened: 'var(--error-50)',
        light: 'var(--error-600)',
        lightDarkened: 'var(--error-700)',
        lighter: 'var(--error-50)',
        lighterDarkened: 'var(--error-100)',
      };
      break;

    default:
      colors = {
        main: 'var(--gray-600)',
        mainDarkened: 'var(--gray-700)',
        contrast: 'var(--gray-contrast)',
        contrastDarkened: 'var(--gray-50)',
        light: 'var(--gray-300)',
        lightDarkened: 'var(--gray-400)',
        lighter: 'var(--gray-50)',
        lighterDarkened: 'var(--primary-100)',
      };
      break;
  }

  switch (variant) {
    case 'soft-outlined':
      return {
        color: colors.main,
        bgColor: colors.lighter,
        border: colors.lighter,
        hover: {
          color: colors.mainDarkened,
          bgColor: colors.lighterDarkened,
          border: colors.lighterDarkened,
        },
      };
    case 'outlined':
      return {
        color: colors.main,
        bgColor: colors.contrast,
        border: colors.light,
        hover: {
          color: colors.mainDarkened,
          bgColor: colors.contrastDarkened,
          border: colors.lightDarkened,
        },
      };
    default:
      return {
        color: colors.contrast,
        bgColor: colors.main,
        border: colors.main,
        hover: {
          color: colors.contrastDarkened,
          bgColor: colors.mainDarkened,
          border: colors.mainDarkened,
        },
      };
  }
};

export default getPalette;
